import React from "react";
import styles from "./SeperatorBlue.module.css";
const SeperatorBlue = () => {
  return <div className={styles.blueSp}></div>;
};

export default SeperatorBlue;
